var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ComingSoon" } },
    [
      _c(
        "div",
        { staticClass: "coming-soon-image" },
        [
          _c("ComingSoonDataIcon", {
            staticStyle: { width: "400px", height: "250px" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "coming-soon-text" }, [
        _c("h3", [
          _vm._v(_vm._s(_vm.noDataText || _vm.$t("chatbotv2.noContentAdded"))),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.scarpOrAddContent")))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comming-soon-btn-container" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function ($event) {
                  _vm.showHowItWorksModal = true
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.howItWorks")))])]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", disabled: _vm.disabled },
              on: {
                click: function () {
                  return _vm.addContent()
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.actionText || _vm.$t("chatbotv2.addContent"))
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showHowItWorksModal
        ? _c(
            "a-modal",
            {
              staticClass: "how-it-works-modal",
              attrs: {
                visible: _vm.showHowItWorksModal,
                footer: null,
                width: 600,
              },
              on: {
                cancel: function ($event) {
                  _vm.showHowItWorksModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "how-it-works-content" }, [
                _c("div", { staticClass: "modal-icon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("info_outline"),
                  ]),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.howItWorks"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-description" }, [
                  _c("p", { staticClass: "intro-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.comingSoonVectorIntro")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "steps" }, [
                    _c("div", { staticClass: "step" }, [
                      _c("div", { staticClass: "step-number" }, [_vm._v("1")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-content" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep1Title"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep1Desc"))
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "step" }, [
                      _c("div", { staticClass: "step-number" }, [_vm._v("2")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-content" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep2Title"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep2Desc"))
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "step" }, [
                      _c("div", { staticClass: "step-number" }, [_vm._v("3")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step-content" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep3Title"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.comingSoonStep3Desc"))
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-box" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("lightbulb_outline"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.comingSoonTip"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: {
                          click: function ($event) {
                            _vm.showHowItWorksModal = false
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chatbotv2.comingSoonGotIt"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }